import { ParserReturnType } from "@/lib/export/crm/types"
import { Square, SquareCheckBig } from "lucide-react"

export default function RenderValue({ value }: { value: ParserReturnType | null | undefined }) {
    return (
        <>
            {(() => {
                if (value instanceof Date) {
                    return value.toISOString()
                }
                if (value === null || value === undefined) {
                    return 'Null'
                }
                if(typeof value === 'boolean'){
                    return value ? <SquareCheckBig/> : <Square/>
                }
                if(typeof value === 'object' && value !== null) {
                    return <span>{JSON.stringify(value)}</span>
                }
                return value
            })()}
        </>
    )
}